import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { CommonModule } from '@angular/common';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-manage-application-nav',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonToggleModule
  ],
  templateUrl: './manage-application-nav.component.html',
  styleUrl: './manage-application-nav.component.scss'
})
export class ManageApplicationNavComponent implements OnInit {
  activeRoute: string = 'accounts';

  constructor(private router: Router) { }

  ngOnInit() {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.updateActiveRoute();
    });

    this.updateActiveRoute();
  }

  updateActiveRoute() {
    const url = this.router.url;

    if (url.includes('/manage-application/accounts')) {
      this.activeRoute = 'accounts';
    } else if (url.includes('/manage-application/users')) {
      this.activeRoute = 'users';
    } else if (url.includes('/manage-application/sites')) {
      this.activeRoute = 'sites';
    } else if (url.includes('/manage-application/platforms')) {
      this.activeRoute = 'platforms';
    } else if (url.includes('/manage-application/posts')) {
      this.activeRoute = 'posts';
    }
  }

  onToggleChange(event: any) {
    this.activeRoute = event.value;

    if (this.activeRoute === 'accounts') {
      this.router.navigate(['/manage-application/accounts']);
    } else if (this.activeRoute === 'users') {
      this.router.navigate(['/manage-application/users']);
    } else if (this.activeRoute === 'sites') {
      this.router.navigate(['/manage-application/sites']);
    } else if (this.activeRoute === 'platforms') {
      this.router.navigate(['/manage-application/platforms']);
    } else if (this.activeRoute === 'posts') {
      this.router.navigate(['/manage-application/posts']);
    }
  }
}